import { DevBoxApi } from './devbox-api';

const delay = (ms = 300) =>
  new Promise<void>(resolve => setTimeout(resolve, ms));

// Used by `yarn start` (devbox.useMockApi) — never in docker-compose/production builds.
export const mockDevBoxApi: DevBoxApi = {
  async listServiceGroups() {
    await delay();
    return [{ id: crypto.randomUUID(), name: 'Sec-mock-devbox' }];
  },
};
